import BaseService from "./geral/BaseService";
import {urlApi} from "../config/Constantes";

const base = "AgendServManter";
const baseConsulta = "AgendServConsulta";
const baseAcompanhamento = "AcompanhamentoProcesso";

export default class AgServicosService extends BaseService {
    constructor() {
        super();
    }

    listar(grupoServId, tipoServId, dataInicial, dataFinal, usuarioId, parceiroId, statusId, numeroBl, codContainer) {
        let filtros = "?";

        if (grupoServId) filtros = filtros.concat(`grupoServId=${grupoServId}`);
        if (tipoServId) filtros = filtros.concat(`&tipoServId=${tipoServId}`);
        if (dataInicial) filtros = filtros.concat(`&dataInicial=${dataInicial}`);
        if (dataFinal) filtros = filtros.concat(`&dataFinal=${dataFinal}`);
        if (usuarioId) filtros = filtros.concat(`&usuarioId=${usuarioId}`);
        if (parceiroId) filtros = filtros.concat(`&parceiroId=${parceiroId}`);
        if (statusId) filtros = filtros.concat(`&indStatus=${statusId}`);
        if (numeroBl) filtros = filtros.concat(`&numBl=${numeroBl}`);
        if (codContainer) filtros = filtros.concat(`&codCntr=${codContainer}`);
        filtros = filtros.replace("?&", "?");

        return super.httpGet(`/${baseConsulta}/ListarAgendamento${filtros}`)
    };

    listarStatus() {
        return super.httpGet(`/${baseConsulta}/ListarStatus`)
    };

    ValidarDadosPesagemSolas = (AgendServ, container) => 
    {
        return this.httpPost(`${base}/ValidarDadosSetPoint?container=${container}`, AgendServ);
    };
    
    ValidarDadosMotorista = (AgendServMotorista, ehEditarTecon=false) => 
    {
        return this.httpPost(`${base}/ValidarDadosMotorista?ehEditarTecon=${ehEditarTecon}`, AgendServMotorista);        
    };
    
    ValidarDadosVeiculo = (AgendServ, ehEditarTecon=false) => 
    {
        return this.httpPost(`${base}/ValidarDadosVeiculo?ehEditarTecon=${ehEditarTecon}`, AgendServ);        
    };
    
    ValidarDadosServicLevante = (agend, ehCarregamentoComboio, ehDesistirVistoria=false, ehEditarTecon=false) => 
    {
        return this.httpPost(`${base}/ValidarDadosServicLevante?ehCarregamentoComboio=${ehCarregamentoComboio}&ehDesistirVistoria=${ehDesistirVistoria}&ehEditarTecon=${ehEditarTecon}`, agend);        
    };
    
    ValidarManuseioSimplesDesovaOva = (agend, ehDesistirVistoria=false, ehEditarTecon=false) => 
    {
        return this.httpPost(`${base}/ValidarManuseioSimplesDesovaOva?ehDesistirVistoria=${ehDesistirVistoria}&ehEditarTecon=${ehEditarTecon}`, agend);
    };
    
    ValidarDadosDesovaCrossdocking = (agend, ehDesistirVistoria=false, ehEditarTecon=false) => 
    {
        return this.httpPost(`${base}/ValidarDadosDesovaCrossdocking?ehDesistirVistoria=${ehDesistirVistoria}&ehEditarTecon=${ehEditarTecon}`, agend);
    };
    
    ValidarDadosDesovaFreetime = (agend, ehDesistirVistoria=false, ehEditarTecon=false) => 
    {
        return this.httpPost(`${base}/ValidarDadosDesovaFreetime?ehDesistirVistoria=${ehDesistirVistoria}&ehEditarTecon=${ehEditarTecon}`, agend);
    };
    
    ValidarDadosDesova = (agend, ehDesistirVistoria=false, ehEditarTecon=false) => 
    {
        return this.httpPost(`${base}/ValidarDadosDesova?ehDesistirVistoria=${ehDesistirVistoria}&ehEditarTecon=${ehEditarTecon}`, agend);
    };
    
    ValidarManuseioImportCargaSolta = (AgendServ, ehEditarTecon=false) => 
    {
        return this.httpPost(`${base}/ValidarManuseioImportCargaSolta?ehEditarTecon=${ehEditarTecon}`, AgendServ);
    };

    ValidarDadosPesagemSolas = (AgendServ, container) => 
    {
        return this.httpPost(`${base}/ValidarDadosPesagemSolas?container=${container}`, AgendServ);
    };
    
    ValidarDadosSetPoint = (AgendServ, container, hstmvId, obs) => 
    {
        return this.httpPost(`${base}/ValidarDadosSetPoint?container=${container}&hstmvId=${hstmvId}&obs=${obs}`, AgendServ);
    };
   
    ValidarDadosExtremContainerAcomp = (agend, ehDesistirVistoria=false, ehEditarTecon=false) => 
    {
        return this.httpPost(`${base}/ValidarDadosExtremContainerAcomp?ehDesistirVistoria=${ehDesistirVistoria}&ehEditarTecon=${ehEditarTecon}`, agend);        
    };
    

    ValidarDadosManuseioExport = (AgendServ, container, ehClienteEstrangeiro, ehDesistirVistoria, ehCobrarCliEstrang,
                                  parcEstabCobrarCliEstrang, parcEstabClienteEstrang, cnpjCobrarParcComerc, cnpjParcComerc) => 
    {
        return this.httpPost(`${base}/ValidarDadosManuseioExport?container=${container}&ehClienteEstrangeiro=${ehClienteEstrangeiro}&ehDesistirVistoria=${ehDesistirVistoria}&ehCobrarCliEstrang=${ehCobrarCliEstrang}&parcEstabCobrarCliEstrang=${parcEstabCobrarCliEstrang}&parcEstabClienteEstrang=${parcEstabClienteEstrang}&cnpjCobrarParcComerc=${cnpjCobrarParcComerc}&cnpjParcComerc=${cnpjParcComerc}`, AgendServ);
    };
    
    listarGrupos = () => {
        return this.httpGet(`${base}/ListarGrupos`);
    };

    listarTipos = (grupoServId) => {
        return this.httpGet(`${base}/ListarTipos?grupoServId=${grupoServId}`);
    };

    listarDatas = (agendTipoServId) => {
        return this.httpGet(`${base}/ListarDatas?tipoServId=${agendTipoServId}`);
    };

    listarBls = () => {
        return this.httpGet(`${base}/ListarBls`);
    };

    listarTransportadoras = () => {
        return this.httpGet(`${base}/Transp/ListarTransportadoras`);
    };

    listarTransportadorasCNPJ = () =>{
        return this.httpGet(`${base}/Transp/ListarTransportadorasCNPJ`)
    };

    listarCategorias = () => {
        return this.httpGet(`${base}/Transp/ListarCategorias`);
    };

    listarOrgaosExpedidores = () => {
        return this.httpGet(`${base}/Transp/ListarOrgaosEmissores`);
    };

    listarContainersPorBl = (blId, tipoServico) => {
        return this.httpGet(`${base}/ListarContainersPorBl/${blId}/${tipoServico}`);
    };


    ListarContainersPorBlConsolidado = (blId) => {
        return this.httpGet(`${base}/ListarContainersPorBlConsolidado/${blId}`);
    };     

    ListarNcmPorBlConsolidado = (blId) => {
        return this.httpGet(`${base}/ListarNcmPorBlConsolidado/${blId}`);
    };   

    listarNcmPorBl = (blId, tipoServico) => {
        return this.httpGet(`${base}/ListarNcmPorBl/${blId}/${tipoServico}`);
    };

    listarNotaFiscalPorBl = (NumBl, ehCarregComboio=false, tipoServico) => {
        return this.httpGet(`${base}/ListarNotaFiscalPorBl?numBl=${NumBl}&ehCarregComboio=${ehCarregComboio}&tipoServico=${tipoServico}`);

    };

    ListarNotaFiscalPorBlConsolidado = (NumBl, ehCarregComboio=false) => {
        return this.httpGet(`${base}/ListarNotaFiscalPorBlConsolidado?numBl=${NumBl}&ehCarregComboio=${ehCarregComboio}`);
    };

    listarContainersSetPoint = () => {
        return this.httpGet(`${base}/ListarContainersSetPoint`);
    };

    recuperarParceiroPorCnpj = (cnpj) => {
        return this.httpGet(`${base}/RecuperarParceiroPorCnpj/${cnpj}`);
    };


    buscarParametrizPorTipo = (agendTipoServId) => {
        return this.httpGet(`${base}/ListarParametrizPorTipo/${agendTipoServId}`);
    };

    listarHoraPorTipoData = (tipoId, data, agendServId) => {
        return this.httpGet(`${base}/ListarHoraPorTipoData/${tipoId}/${data}/${agendServId}`);
    };

    listarClientesEstrangeiros = () => {
        return this.httpGet(`${base}/ListarClientesEstrangeiros`);
    };

    listarClientes = () => {
        return this.httpGet(`${baseConsulta}/ListarClientes`);
    };

    listarTipoVeiculos = () => {
        return this.httpGet(`${base}/ListarTipoVeiculos`);
    };

    carregarDadosBl = (blId, tipoServico) => {
        return this.httpGet(`${base}/CarregarDadosBl/${blId}/${tipoServico}`);
    };

    // carregarDadosBl = (blId) => {
    //     return this.httpGet(`${base}/CarregarDadosBl/${blId}`);
    // };

    CarregarDadosBlMultiplos = (blId) => {
        return this.httpGet(`${base}/CarregarDadosBlMultiplos/${blId}`);
    };

    listarContainersPorBooking = (numBooking) => {
        return this.httpGet(`${base}/ListarContainersPorBooking/${numBooking}`);
    };

    carregarAgendServ = (agendServId) => {
        return this.httpGet(`${base}/CarregarAgendServ/${agendServId}`);
    };

    carregarMotoristaPorCnh = (cnh) => {
        return this.httpGet(`${base}/Transp/RecuperarDadosMotorista/?cnh=${cnh}`);
    };

    validarBl = (blId, agendTipoServId) => {
        return this.httpGet(`${base}/ValidarBl/${blId}/${agendTipoServId}`);
    };

    validarBlMultiplo = (blId, agendTipoServId) => {
        return this.httpGet(`${base}/validarBlMultiplo/${blId}/${agendTipoServId}`);
    };

    apenasVeiculo = (agendServId) => {
        return this.httpGet(`${base}/ApenasVeiculo/${agendServId}`);
    };

    cancelar = (agendServId) => {
        return this.httpGet(`${baseConsulta}/CancelarAgendamento?agendServId=${agendServId}`);
    };
    
    salvar = (agendamento) => {
        return this.httpPost(`${base}/Salvar`, agendamento);
    };
    
    excluirAnexo = (agendServAnexId) => {
        return this.httpPost(`${base}/ExcluirAnexo?agendServAnexId=${agendServAnexId}`);
    };

    salvarAnexo(doc, dscAnexo, agendServId, extensao) {
        let filtros = "?";
        
        if (!extensao) 
            extensao = null;
            
        filtros = filtros.concat(`extensao=${extensao}`); 
        if (dscAnexo) filtros = filtros.concat(`&dscAnexo=${dscAnexo}`);
        if (agendServId) filtros = filtros.concat(`&agendServId=${agendServId}`);
        //filtros = filtros.replace("?&", "?");

        return super.httpPost(`/${base}/SalvarAnexo${filtros}`, doc)
    }

    mostrarAnexo = (agendServAnexId) => {
        return `${urlApi}/${base}/DownloadAnexo/${agendServAnexId}`; 
    };

    desistirVistoria = (docId) => {
        return super.httpGet(`/${baseAcompanhamento}/DesistirVistoriaSsa?docId=${docId}`);
    }

    //multiplos carregamento de carga consolidada
    VerificaDadosBlConsolidado = (blId) => {
        return this.httpGet(`${base}/VerificaDadosBlConsolidado/${blId}`);
    };

    listarMultiplos(id, grupoServId, tipoServId, placa, hora, dat) {
        let filtros = "?";
        if (id) filtros = filtros.concat(`id=${id}`);
        if (grupoServId) filtros = filtros.concat(`&grupoServId=${grupoServId}`);
        if (tipoServId) filtros = filtros.concat(`&tipoServId=${tipoServId}`);
        if (placa) filtros = filtros.concat(`&placa=${placa}`);
        if (hora) filtros = filtros.concat(`&hora=${hora}`);
        if (dat) filtros = filtros.concat(`&DatAgend=${dat}`);

        filtros = filtros.replace("?&", "?");

        return super.httpGet(`/${base}/ListarAgendamentoMultiplos${filtros}`)
    };


    salvarMultiplos = (agendamento) => {
        return this.httpPost(`${base}/SalvarMultiplos`, agendamento);
    };

    
    // region referencias
    sample = {
        AgendServ: {
            Id: 0,
            TranspId: null,
            AgendTipoServId: 0,
            IndStatus: "",
            DatAgend: "",
            HoraAgend: 0,
            Cnh: 0,
            PlacaCavalo: "",
            PlacaCarret1: "",
            PlacaCarret2: "",
            MembershipuseridIncl: 0,
            DatIncl: "",
            CdLoc: "",
            DatUsuAlt: "",
            UsuAlt: null,
            AnaliCritId: null,
            BlId: null,
            NumeroBl: "",
            NumBooking: null,
            ParcIdCobrar: null,
            EstabIdCobrar: null,
            ParcIdDespa: null,
            EstabIdDespa: null,
            FlgComboio: "N",
            EadiId: null,
            DscObs: "",
            IndStatusOsGerad: "",
            DiasFreetime: null,
            IndVeic: "",
            DatFimPrev: "",
            MembershipuseridInclTecon: null,
            MercId: null,
            FlgCancOsNoShow: "",
            EhClienteEstrangeiro: false,
            EhCobrarDeEstrangeiro: false,
            DataHoraAgendFormat: "",
            DesistiuVistoria: false,
            RefTipoServ: "",
            DscTipoServ: "",
            DscGrupo: "",
            CnpjDespa: "",
            CnpjCobrar: "",
            RazaoSocialDespa: "",
            RazaoSocialCobrar: "",
            AgendGroupServ: 0
        },
        AgendServMotorista: {
            Cnh: 0,
            CategCnh: "",
            Cpf: 0,
            Identidade: 0,
            OrgEmissId: null,
            Nome: "",
            Id: 0,
            CnhString: "",
            CpfString: "",
            IdentidadeString: ""
        },
        AgendServItens: [
            // {
            //     Id: 0,
            //     AgendServId: 0,
            //     IndStatus: "",
            //     UnitId: 0,
            //     Volumes: 0,
            //     CodCntr: "",
            //     IndExcluido: "",
            //     Excluir: true,
            //     NotasFiscais: [
            //         {
            //             Id: 0,
            //             NumeroNota: null,
            //             AgendServItemId: 0,
            //             ProtocoloInfDocId: 0,
            //             QtdVolume: 0,
            //             Excluir: false
            //         }
            //     ]
            // }
        ],
        AgendServItemMerc: [
            // {
            //     Id: 0,
            //     AgendServItemId: 0,
            //     AgendServId: 0,
            //     Excluir: true
            // }
        ],
        AgendServAnexos: [
            // {
            //     Id: 0,
            //     AgendServId: 0,
            //     ValAnexo: "QEA=",
            //     DscAnexo: "",
            //     DscExtenAnexo: "",
            //     FlgEnvioOsConc: "",
            //     FlgEnvioOsFech: "",
            //     Excluir: true
            // }
        ],
        UsuarioId: 0,
        UsuarioIdTecon: null
    };

    refCamposDesovaFreeMapa = {
        dadosDoBl: true,
        inputMostraCliente: true,
        selectBL: true,
        selectNCM: true,

        dadosDoCntr: true,
        tabelaSelecionarContainers: true,
        inputVolume: true,

        dadosGerais: true,
        inputObservacao: true,
        campoInsereAnexos: true,
        inputDiasFreetime: true,

        msgAnexos: "Obrigatório inserir packlist e BL.",
        msgNCM: "Lista de NCMs com Análise Crítica aprovada.",

        camposObrigatorios: {
            selectBL: true,
            inputVolume: true,
            dadosDoCntr: true,
            tabelaSelecionarContainers: true,
            campoInsereAnexos: true,
            selectNCM: true,
        }
    };

    refCamposDesovaAcompanhada = {
        dataHora: true,

        dadosDoBl: true,
        inputMostraCliente: true,
        selectBL: true,
        selectNCM: true,

        dadosDoCntr: true,
        tabelaSelecionarContainers: true,
        inputVolume: true,

        dadosGerais: true,
        inputObservacao: true,
        campoInsereAnexos: true,
        inputDiasFreetime: true,

        msgAnexos: "Obrigatório inserir packlist e BL.",
        msgNCM: "Lista de NCMs com Análise Crítica aprovada.",

        camposObrigatorios: {
            selectBL: true,
            inputVolume: true,
            dadosDoCntr: true,
            tabelaSelecionarContainers: true,
            campoInsereAnexos: true,
            selectNCM: true,
            dataHora: true
        }
    };

    refCamposDesovaCrossdocking = {
        dataHora: true,

        dadosDoBl: true,
        inputMostraCliente: true,
        selectBL: true,
        selectNCM: true,
        checkboxComboio: true,

        dadosDoCntr: true,
        tabelaSelecionarContainers: true,
        selectNotas: true,

        dadosGerais: true,
        inputObservacao: true,
        campoInsereAnexos: true,
        inputDiasFreetime: true,

        dadosDaTransportadora: true,
        selectTransportadora: true,
        selectTipoDeVeiculo: true,
        inputPlaca: true,
        inputCarreta1: true,
        inputCarreta2: true,
        
        msgNCM: "Lista de NCMs com Análise Crítica aprovada.",

        dadosDoMotorista: true,
        inputCNH: true,
        selectCategoria: true,
        inputNome: true,
        inputCPF: true,
        inputIdentidade: true,
        selectOrgaoExpedidor: true,

        camposObrigatorios: {
            selectBL: true,
            dadosDoCntr: true,
            tabelaSelecionarContainers: true,
            selectNotas: true,
            campoInsereAnexos: true,
            dadosDaTransportadora: true,
            dadosDoMotorista: true,
            botaoAdicionarEmContainers: true,
            selectNCM: true,
            dataHora: true
        }
    };

    refCamposCarregamentoCargaSolta = {
        dataHora: true,

        dadosDoBl: true,
        inputMostraCliente: true,
        selectBL: true,
        checkboxComboio: true,

        dadosDoCntr: true,
        dadosGerais: true,
        tabelaSelecionarContainers: true,
        selectNotas: true,
        inputObservacao: true,
        campoInsereAnexos: true,

        dadosDaTransportadora: true,
        selectTransportadora: true,
        selectTipoDeVeiculo: true,
        inputPlaca: true,
        inputCarreta1: true,
        inputCarreta2: true,

        dadosDoMotorista: true,
        inputCNH: true,
        selectCategoria: true,
        inputNome: true,
        inputCPF: true,
        inputIdentidade: true,
        selectOrgaoExpedidor: true,

        camposObrigatorios: {
            selectBL: true,
            tabelaSelecionarContainers: true,
            selectNotas: true,
            botaoAdicionarEmContainers: true,
            dadosDaTransportadora: true,
            dadosDoMotorista: true,
        }
    };

    refCamposManuseioImportacao = {
        dataHora: false,

        dadosDoBl: true,
        inputMostraCliente: true,
        selectBL: true,
        selectNCM: true,

        dadosDoCntr: true,
        dadosGerais: true,
        tabelaSelecionarContainers: true,
        inputObservacao: true,
        campoInsereAnexos: true,

        desistenciaDeVistoria: true,

        msgAnexos: "Para vistoria com desova e ova, será necessário anexar Packing list e BL.",
        msgNCM: "Lista de NCMs com Análise Crítica aprovada.",

        camposObrigatorios: {
            selectBL: true,
            dadosDoCntr: true,
            tabelaSelecionarContainers: true,
            desistenciaDeVistoria: true,
            selectNCM: true,
        }
    };

    refCamposManuseioImportacaoTwo = {
        dataHora: true,

        dadosDoBl: true,
        inputMostraCliente: true,
        selectBL: true,

        dadosDoCntr: true,
        dadosGerais: true,
        
        tabelaSelecionarContainers: true,
        inputObservacao: true,
        campoInsereAnexos: true,

        msgAnexos: "Para vistoria com desova e ova, será necessário anexar Packing list e BL.",

        camposObrigatorios: {
            selectBL: true,
        }
    };

    refCamposManuseioExportacao = {
        dadosGerais: true,
        inputContainer: true,
        inputCliente: true,
        inputMostraRazSocial: true,
        checkEhClienteEstrangeiro: true,
        selectClienteEstrangeiro: true,
        inputCobrarDe: true,
        inputMostraRazSocialCobrarDe: true,
        checkEhCobrarDeEstrangeiro: true,
        selectCobrarDeEstrangeiro: true,
        inputObservacao: true,
        campoInsereAnexos: true,

        camposObrigatorios: {
            inputContainer: true,
            inputCliente: true,
            inputCobrarDe: true,
        }
    };

    refCamposPesagem = {
        pesagemSolas: true,
        selectBL: true,
        inputContainer: true,

        camposObrigatorios: {
            inputContainer: true,
        }
    };

    refCamposPesagemExportacao = {
        pesagemContainersExportacao: true,
        inputBooking: true,
        tabelaSelecionarContainers: true,
        inputCliente: true,
        inputMostraRazSocial: true,
        checkEhClienteEstrangeiro: true,
        selectClienteEstrangeiro: true,
        inputCobrarDe: true,
        inputMostraRazSocialCobrarDe: true,
        checkEhCobrarDeEstrangeiro: true,
        selectCobrarDeEstrangeiro: true,
        campoInsereAnexos: true,

        camposObrigatorios: {
            inputBooking: true,
            tabelaSelecionarContainers: true,
        }
    };

    refCamposPesagemImportacao = {
        pesagemContainersImportacao: true,
        selectBL: true,
        inputMostraCliente: true,
        tabelaSelecionarContainers: true,
        inputObservacao: true,
        campoInsereAnexos: true,

        camposObrigatorios: {
            inputBl: true,
            tabelaSelecionarContainers: true,
        }
    };

    refCamposAjusteSetPoint = {
        dadosGerais: true,
        selectContainer: true,
        inputObservacao: true,

        camposObrigatorios: {
            selectContainer: true,
        }
    };
    // endregion
}


// WEBPACK FOOTER //
// ./src/services/AgServicosService.js